// eslint-disable-next-line no-restricted-imports
import { A } from 'dripsy';

export default A;
